// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentProviders, importProvidersFrom } from "@angular/core";
import { HttpClientInMemoryWebApiModule } from "angular-in-memory-web-api";
import { InMemoryBackend } from "src/app/mocks/in-memory-backend";

export const environment = {
  production: false,
};

const useInmemoryBackend = false;
export function provideInMemoryBackendConfig(): EnvironmentProviders {
  if (!useInmemoryBackend) {
    return importProvidersFrom([]);
  }
  return importProvidersFrom([
    HttpClientInMemoryWebApiModule.forRoot(InMemoryBackend, {
      apiBase: '/',
      host: '',
      passThruUnknownUrl: true
    })
  ]);
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
